import { useEffect } from "react";

export function useHostedStripeRedirectWaitingReset(
  waiting: boolean,
  setWaiting: (value: boolean) => void,
) {
  useEffect(() => {
    if (!waiting) {
      return;
    }

    const clearWaiting = () => {
      setWaiting(false);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        clearWaiting();
      }
    };

    window.addEventListener("pageshow", clearWaiting);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pageshow", clearWaiting);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [setWaiting, waiting]);
}
